export function requireTenant(tenantId: string | null): string {
  if (!tenantId) {
    throw new Error('No tenant selected');
  }
  return tenantId;
}

export function requireParam<T>(
  value: T | undefined | null,
  errorMessage: string
): T {
  if (value === undefined || value === null || value === '') {
    throw new Error(errorMessage);
  }
  return value;
}
